export default __webpack_public_path__ + "static/media/rocket.c8cf3e7f.png";